import UltMeta, { Meta } from "./UltMeta/index";

class Type extends UltMeta {
    PRIVACY_AGREEMENT = new Meta(1, "隐私政策");
    USER_AGREEMENT = new Meta(2, "用户协议");
}

class App extends UltMeta {
    SUPPLIER_PC = new Meta(1, "供应链端PC端");
    BACKEND_PC = new Meta(2, "管理后台PC端");
    SUPPLIER_MOBILE = new Meta(3, "供应链端移动端");
    BACKEND_MOBILE = new Meta(4, "管理后台移动端");
}

export const TYPE = new Type();
export const APP = new App();
